import { firebaseAuth } from './firebase.js';

const API_BASE = import.meta.env.VITE_API_BASE;

async function apiFetch(path, options = {}) {
  const user = firebaseAuth.currentUser;
  const token = user ? await user.getIdToken() : null;
  const url = `${API_BASE}${path}`;
  const response = await fetch(url, {
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...options.headers,
    },
    ...options,
  });

  if (!response.ok) {
    const err = new Error(`API error: ${response.status} ${response.statusText}`);
    err.status = response.status;
    throw err;
  }

  return response.json();
}

export const worksheetApi = {
  /**
   * Fetch all live EPLUS_LEARN question packs ordered by rownum.
   * @returns {Promise<{ packs: Array }>}
   */
  async getPacks(type = 'TOPIC') {
    return apiFetch(`/question-packs?type=${type}`);
  },

  /**
   * Fetch the most recent daily worksheet record for a pack.
   * Returns pdfUrl + pdfReady so the UI can show a direct download link.
   *
   * @param {string} packId  — pack _id or slug
   * @returns {Promise<{ packId, date, pdfUrl, pdfReady, questionCount, generatedAt }>}
   */
  async getDailyWorksheet(packId) {
    return apiFetch(`/worksheets?packId=${encodeURIComponent(packId)}&includeQuestions=true`);
  },
};
